import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveIdentificationNumbersMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveIdentificationNumbersParam } from 'api/types/params';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveIdentificationNumbers = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveIdentificationNumbersMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveIdentificationNumbers
      ? parseLegalClient(data.legalClientSaveIdentificationNumbers)
      : undefined,
    loading,
    error,
    saveIdentificationNumbers: useCallback(
      async (id: string, params: LegalClientSaveIdentificationNumbersParam) => {
        const res = await handle({
          variables: {
            id,
            input: { giin: params.GIIN, lei: params.LEI },
          },
        });
        return res.data?.legalClientSaveIdentificationNumbers
          ? parseLegalClient(res.data.legalClientSaveIdentificationNumbers)
          : undefined;
      },
      [handle]
    ),
  };
};
